import { useState, useRef, useEffect } from "react";

const SuccessView = ({ caseId }: { caseId: string }) => {
  const [copied, setCopied] = useState(false);
  const copyTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      if (copyTimeoutRef.current) {
        clearTimeout(copyTimeoutRef.current);
      }
    };
  }, []);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(caseId);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = caseId;
      ta.style.cssText = "position:fixed;top:-9999px;left:-9999px;opacity:0;";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    if (copyTimeoutRef.current) {
      clearTimeout(copyTimeoutRef.current);
    }
    copyTimeoutRef.current = setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="min-h-dvh flex flex-col items-center justify-center bg-background text-foreground px-lg">
      <div className="max-w-[480px] w-full flex flex-col items-center text-center gap-lg">
        <div className="w-[72px] h-[72px] rounded-full bg-[rgba(29,172,0,0.1)] flex items-center justify-center">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true">
            <path d="M7 16.5L13 22.5L25 10" stroke="#1dac00" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <div className="flex flex-col gap-sm">
          <h1 className="text-lg font-bold">Message sent</h1>
          <p className="text-base text-muted-fg leading-relaxed max-w-[340px]">
            Our team will review your request and reply to your email. Save your case ID for follow-ups.
          </p>
        </div>
        <div className="flex flex-col items-center gap-sm w-full">
          <span className="text-sm text-muted-fg">Your case ID</span>
          <span className="font-mono text-md font-bold tracking-[0.12em] text-foreground select-all">{caseId}</span>
          <button
            type="button"
            onClick={copy}
            className="btn-primary mt-xs h-[48px] px-[32px] rounded-full bg-foreground text-primary-fg text-base font-semibold cursor-pointer shadow-[0_2px_8px_rgba(0,0,0,0.12)]"
          >
            {copied ? "Copied!" : "Copy Case ID"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SuccessView;
